import React from 'react';

// Six-armed asterisk mark matching the DigitalWorks brand icon.
// Each arm is a rounded pill radiating from a shared centre at 60° increments,
// with a small gap at the centre.
export default function Logo({ size = 36, showText = true, inverted = false }) {
  const inkColor = inverted ? '#FBFAF6' : '#1A1A1A';
  const green = '#22A94F';

  // Arm: a rounded pill from radius rMin to rMax along +Y axis.
  // We rotate a copy every 40 degrees for a nine-spoke asterisk that reads
  // distinctly from the common six-spoke mark.
  const rMin = 4.4;    // gap radius from centre
  const rMax = 22.5;   // arm outer end
  const armWidth = 4.4; // arm thickness — slimmed to keep the mark uncluttered at 9 spokes

  const arm = (
    <rect
      x={-armWidth / 2}
      y={-rMax}
      width={armWidth}
      height={rMax - rMin}
      rx={armWidth / 2}
      ry={armWidth / 2}
    />
  );

  return (
    <div className="flex items-center gap-2.5" aria-label="DigitalWorks">
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g transform="translate(24 24)" fill={green}>
          {[0, 40, 80, 120, 160, 200, 240, 280, 320].map((deg) => (
            <g key={deg} transform={`rotate(${deg})`}>
              {arm}
            </g>
          ))}
        </g>
      </svg>
      {showText && (
        <div className="flex flex-col leading-none">
          <div
            className="flex items-baseline"
            style={{
              fontFamily: "'Fraunces', 'Instrument Serif', 'Times New Roman', serif",
              color: inkColor,
              fontFeatureSettings: '"ss01", "ss02"',
              letterSpacing: '-0.035em',
            }}
          >
            <span className="text-[22px]" style={{ fontWeight: 400 }}>Digital</span>
            <span className="text-[22px]" style={{ fontWeight: 600 }}>Works</span>
          </div>
          <span
            className="text-[9px] mt-[5px] uppercase"
            style={{
              fontFamily: "'JetBrains Mono', 'IBM Plex Mono', ui-monospace, Menlo, monospace",
              color: inkColor,
              opacity: 0.62,
              letterSpacing: '0.28em',
            }}
          >
            Consulting Group
          </span>
        </div>
      )}
    </div>
  );
}
